export const roMembraneProducts = {
  'residential-ro-membrane': {
    title: 'Residential Series RO Membrane Elements',
    category: 'RO Membrane Series',
    description: 'Compact and efficient reverse osmosis membrane elements designed specifically for residential applications.',
    longDescription: 'Residential Series RO membrane elements are specifically designed for home water treatment systems. These membranes offer various sizes and capacities to meet different household needs, providing high-quality drinking water with excellent salt rejection rates. The compact design makes them ideal for under-sink purifiers and point-of-use water treatment systems.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/e61e11d0b3f7320d5e57a3d49e6eab82.png',
    features: [
      'Compact design perfect for residential use',
      'Various sizes available (50G to 400G)',
      'High salt rejection rate of 97%',
      'Low operating pressure (65 PSI)',
      'Cost-effective solution for home water treatment',
      'Easy installation and maintenance'
    ],
    specifications: {
      'Operating Pressure': '65 PSI (0.45 MPa)',
      'Max Operating Pressure': '300 PSI (2.0 MPa)',
      'Max Feed Water Temperature': '45°C',
      'Max SDI of Feedwater': '5',
      'Max Concentration of Free Chlorine': '<0.1mg/l',
      'pH Value Range of Continual Feedwater': '3-10',
      'pH Value Range of Income Water When Chemical Cleaning': '2-11',
      'Max Pressure Drop of Single Membrane': '10psi (0.07MPa)',
      'Salt Rejection Rate': '97%',
      'Recovery Rate': '15%'
    },
    testConditions: {
      'Testing Pressure': '50-125G: 65psi(0.45MPa), 200-400G: 100psi(0.69MPa)',
      'Testing Temperature': '25°C',
      'Concentration of Testing Solution (NaCl)': '500ppm',
      'pH Value of Testing Solution': '6.5-7.5',
      'Recovery Rate of Single Membrane Element': '15%',
      'Permeate Flow Variation': '±15%'
    },
    applications: [
      'Under-sink water purifiers',
      'Point-of-use water treatment',
      'Home RO systems',
      'Small office water treatment',
      'Residential drinking water preparation'
    ],
    models: [
      {
        model: 'RE-1812-50G',
        activeArea: '3.5(0.32)',
        operatingPressure: '65(0.45)',
        temperature: '25°C',
        permeateFlux: '58(204)',
        saltRejection: '97',
        recovery: '15'
      },
      {
        model: 'RE-1812-75G',
        activeArea: '4.2(0.38)',
        operatingPressure: '65(0.45)',
        temperature: '25°C',
        permeateFlux: '75(281)',
        saltRejection: '97',
        recovery: '15'
      },
      {
        model: 'RE-2012-100G',
        activeArea: '5.0(0.46)',
        operatingPressure: '65(0.45)',
        temperature: '25°C',
        permeateFlux: '100(380)',
        saltRejection: '97',
        recovery: '15'
      },
      {
        model: 'RE-2012-125G',
        activeArea: '5.4(0.50)',
        operatingPressure: '65(0.45)',
        temperature: '25°C',
        permeateFlux: '125(478)',
        saltRejection: '97',
        recovery: '15'
      },
      {
        model: 'RE-3012-200G',
        activeArea: '10(1.0)',
        operatingPressure: '100(0.69)',
        temperature: '25°C',
        permeateFlux: '200(760)',
        saltRejection: '97',
        recovery: '15'
      },
      {
        model: 'RE-3012-300G',
        activeArea: '14(1.4)',
        operatingPressure: '100(0.69)',
        temperature: '25°C',
        permeateFlux: '300(1135)',
        saltRejection: '97',
        recovery: '15'
      },
      {
        model: 'RE-3012-400G',
        activeArea: '16(1.92)',
        operatingPressure: '100(0.69)',
        temperature: '25°C',
        permeateFlux: '400(1512)',
        saltRejection: '97',
        recovery: '15'
      }
    ],
    dimensions: [
      { model: 'RE-1812-50G', length: '12"', diameter: '1.8"' },
      { model: 'RE-1812-75G', length: '12"', diameter: '1.8"' },
      { model: 'RE-2012-100G', length: '12"', diameter: '2.0"' },
      { model: 'RE-2012-125G', length: '12"', diameter: '2.0"' },
      { model: 'RE-3012-200G', length: '12"', diameter: '3.0"' },
      { model: 'RE-3012-300G', length: '12"', diameter: '3.0"' },
      { model: 'RE-3012-400G', length: '12"', diameter: '3.0"' }
    ]
  },
  'ro-membrane-bw-series': {
    title: 'Brackish Water (BW) RO Membrane Element Series',
    category: 'RO Membrane Series',
    description: 'Advanced brackish water reverse osmosis membrane elements with low-pressure operation and high permeate flow for excellent desalination performance.',
    longDescription: 'BW Series RO membrane element has the properties of low-pressure operation, high permeate flow and excellent desalination and it is applicable to desalination of brackish water. Besides, it is particularly applicable to fabrication of high-purity water for electronic industry and electric power industry owing to its excellent performance in removing soluble salts, TOC, SiO2, etc. It is applicable to the desalination of surface water, groundwater and water treatment with salt concentration between 2000 and 8000ppm. It can be widely used in the medicine, chemical industry, beverage, electricity and other various industries etc.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/4073b1acdfc641211dda123cf4d1dc29.png',
    features: [
      'Low-pressure operation reduces energy consumption',
      'High permeate flow and excellent desalination performance',
      'Excellent performance in removing soluble salts, TOC, SiO2',
      'Applicable to salt concentration between 2000-8000ppm',
      'Wide application in various industries',
      'Stable rejection rate and high recovery rate'
    ],
    specifications: {
      'Operating Pressure': '225 PSI (1.55 MPa)',
      'Max Feed Water Temperature': '45°C',
      'Active Area': '36-400 ft² (3.4-37 m²)',
      'Salt Rejection Rate': '99.5%',
      'Recovery Rate': '8-15%',
      'Max Feed Water Salinity': '6000 μg/cm',
      'Max Feed Water Hardness': '60 ppm',
      'Max Feed Water COD': '10 ppm',
      'Max Feed Water BOD': '5 ppm',
      'Max Feed Water TOC': '10 ppm',
      'Max Feed Water Free Chlorine': '<0.1 ppm',
      'Max Feed Water Turbidity NTU': '1.0',
      'Max Feed Water SDI 15': '5',
      'Continuous Feed Water pH Range': '2-11',
      'Chemical Cleaning pH Range': '1-13'
    },
    testConditions: {
      'Temperature of Testing Solution': '25°C',
      'Concentration of Testing Solution (NaCl)': '2000ppm',
      'Operating Condition': '225psi (1.55MPa)',
      'pH Value of Testing Solution': '7.5-8',
      'Recovery Rate of Single Element': '15%(8040, 4040, 2540), 8%(4021, 2521)',
      'Permeate Flow Variation': '±15%'
    },
    applications: [
      'Desalination of surface water and groundwater',
      'Water treatment with salt concentration 2000-8000ppm',
      'Electronic industry high-purity water fabrication',
      'Electric power industry water treatment',
      'Medicine and chemical industry applications',
      'Beverage industry water treatment',
      'Various industrial water treatment applications'
    ],
    models: [
      {
        model: 'BW-4021',
        workingPressure: '600(4.14)',
        operatingPressure: '225(1.55)',
        temperature: '45°C',
        activeArea: '36(3.4)',
        permeateFlux: '950(3.6)',
        saltRejection: '99.3',
        recovery: '8'
      },
      {
        model: 'BW-4040',
        workingPressure: '600(4.14)',
        operatingPressure: '225(1.55)',
        temperature: '45°C',
        activeArea: '85(7.9)',
        permeateFlux: '1900(7.2)',
        saltRejection: '99.5',
        recovery: '15'
      },
      {
        model: 'BW-8040',
        workingPressure: '600(4.14)',
        operatingPressure: '225(1.55)',
        temperature: '45°C',
        activeArea: '400(37)',
        permeateFlux: '10500(39.5)',
        saltRejection: '99.5',
        recovery: '15'
      }
    ],
    dimensions: [
      { model: 'BW-4021', length: '21"', diameter: '4.0"' },
      { model: 'BW-4040', length: '40"', diameter: '4.0"' },
      { model: 'BW-8040', length: '40"', diameter: '8.0"' }
    ]
  },
  'ulp-ro-membrane': {
    title: 'Ultra-Low Pressure (ULP) RO Membrane Element Series',
    category: 'RO Membrane Series',
    description: 'Advanced ultra-low pressure reverse osmosis membrane elements designed for high efficiency water treatment.',
    longDescription: 'ULP Series RO membrane element can work under ultra low pressure to reach as high permeate flow and salt rejection as regular low-pressure membrane element can, and is applicable to desalination of surface water and underground water. It operates under approximately two thirds of the operating pressure of regular low-pressure composite membranes, and achieves a salt rejection rate up to 99.5%, which can decrease the investment costs for such relevant facilities as pumps, pipelines, and containers, etc. and the operating cost for the RO system, thus increasing the economic efficiency.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/4073b1acdfc641211dda123cf4d1dc29.png',
    features: [
      'Ultra-low operating pressure reduces energy consumption',
      'High salt rejection rate up to 99.5%',
      'Decreased investment and operating costs',
      'Applicable to surface water and underground water',
      'Wide application in residential dual water supplying system'
    ],
    specifications: {
      'Operating Pressure': '150 PSI (1.05 MPa)',
      'Max Feed Water Temperature': '45°C',
      'Active Area': '37-400 ft² (3.4-37 m²)',
      'Salt Rejection Rate': '99.3%',
      'Recovery Rate': '8-15%',
      'Max Feed Water Salinity': '2000 μg/cm',
      'Max Feed Water Hardness': '60 ppm',
      'Max Feed Water COD': '10 ppm',
      'Max Feed Water BOD': '5 ppm',
      'Max Feed Water TOC': '10 ppm',
      'Max Feed Water Free Chlorine': '<0.1 ppm',
      'Max Feed Water Turbidity NTU': '1.0',
      'Max Feed Water SDI 15': '5',
      'Continuous Feed Water pH Range': '2-11',
      'Chemical Cleaning pH Range': '1-13'
    },
    testConditions: {
      'Temperature of Testing Solution': '25°C',
      'Concentration of Testing Solution (NaCl)': '1500ppm',
      'Operating Condition': '150psi (1.03MPa)',
      'pH Value of Testing Solution': '7.5-8',
      'Recovery Rate of Single Element': '15%(8040, 4040, 2540), 8%(4021, 2521)',
      'Permeate Flow Variation': '±15%'
    },
    applications: [
      'Municipal water desalination',
      'Groundwater treatment with salt concentration less than 200ppm',
      'Residential dual water supplying system',
      'Pure water preparation plant',
      'Industrial water treatment',
      'Food production and other fields'
    ],
    models: [
      {
        model: 'ULP-2521',
        workingPressure: '600(4.14)',
        operatingPressure: '150(1.05)',
        temperature: '45°C',
        activeArea: '14(1.3)',
        permeateFlux: '400(1.51)',
        saltRejection: '99.3',
        recovery: '8'
      },
      {
        model: 'ULP-2540',
        workingPressure: '600(4.14)',
        operatingPressure: '150(1.05)',
        temperature: '45°C',
        activeArea: '27(2.5)',
        permeateFlux: '750(2.84)',
        saltRejection: '99.3',
        recovery: '15'
      },
      {
        model: 'ULP-4021',
        workingPressure: '600(4.14)',
        operatingPressure: '150(1.05)',
        temperature: '45°C',
        activeArea: '36(3.4)',
        permeateFlux: '950(3.6)',
        saltRejection: '99.3',
        recovery: '8'
      },
      {
        model: 'ULP-4040',
        workingPressure: '600(4.14)',
        operatingPressure: '150(1.05)',
        temperature: '45°C',
        activeArea: '85(7.9)',
        permeateFlux: '1900(7.2)',
        saltRejection: '99.3',
        recovery: '15'
      },
      {
        model: 'ULP-8040',
        workingPressure: '600(4.14)',
        operatingPressure: '150(1.05)',
        temperature: '45°C',
        activeArea: '400(37)',
        permeateFlux: '10500(39.5)',
        saltRejection: '99.3',
        recovery: '15'
      }
    ],
    dimensions: [
      { model: 'ULP-2521', length: '21"', diameter: '2.5"' },
      { model: 'ULP-2540', length: '40"', diameter: '2.5"' },
      { model: 'ULP-4021', length: '21"', diameter: '4.0"' },
      { model: 'ULP-4040', length: '40"', diameter: '4.0"' },
      { model: 'ULP-8040', length: '40"', diameter: '8.0"' }
    ]
  },
  'fouling-resistant-ro-membrane': {
    title: 'Fouling Resistant (FR) RO Membrane Element Series',
    category: 'RO Membrane Series',
    description: 'Advanced fouling resistant reverse osmosis membrane elements with excellent anti-fouling properties.',
    longDescription: 'FR Series RO membrane element is characterized by high rejection and excellent anti-fouling property. Special treatment is made to membrane surface with unique technology to change its electrical charge and smoothness, increasing the hydrophilicity of the membrane surface, thus decreasing the adhesion of contamination and microbe so as to lessen the pollution and extend the service life of membrane element. It is particularly applicable for treatment of surface water, industrial wastewater, desalination of brackish water with mid-high salt concentration.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/4073b1acdfc641211dda123cf4d1dc29.png',
    features: [
      'Excellent anti-fouling properties with special surface treatment',
      'Extended membrane service life',
      'High salt rejection rate',
      'Suitable for challenging water conditions',
      'Reduced cleaning frequency and maintenance costs'
    ],
    specifications: {
      'Operating Pressure': '225 PSI (1.55 MPa)',
      'Max Feed Water Temperature': '45°C',
      'Active Area': '85-400 ft² (7.9-37 m²)',
      'Salt Rejection Rate': '99.5%',
      'Recovery Rate': '8-15%',
      'Max Feed Water Salinity': '6000 μg/cm',
      'Max Feed Water Hardness': '60 ppm',
      'Max Feed Water COD': '10 ppm',
      'Max Feed Water BOD': '5 ppm',
      'Max Feed Water TOC': '10 ppm',
      'Max Feed Water Free Chlorine': '<0.1 ppm',
      'Max Feed Water Turbidity NTU': '1.0',
      'Max Feed Water SDI 15': '5',
      'Continuous Feed Water pH Range': '2-11',
      'Chemical Cleaning pH Range': '1-13'
    },
    testConditions: {
      'Temperature of Testing Solution': '25°C',
      'Concentration of Testing Solution (NaCl)': '2000ppm',
      'Operating Condition': '225psi (1.55MPa)',
      'pH Value of Testing Solution': '7.5-8',
      'Recovery Rate of Single Element': '15%(8040, 4040), 8%(4021, 2521)',
      'Permeate Flow Variation': '±15%'
    },
    applications: [
      'Surface water treatment',
      'Industrial wastewater desalination',
      'Brackish water with mid-high salt concentration',
      'Medicine and chemical industry applications',
      'Beverage and electricity industry',
      'Various industrial applications'
    ],
    models: [
      {
        model: 'BW-4021FR',
        workingPressure: '600(4.14)',
        operatingPressure: '225(1.55)',
        temperature: '45°C',
        activeArea: '85(7.9)',
        permeateFlux: '950(3.6)',
        saltRejection: '99.5',
        recovery: '8'
      },
      {
        model: 'BW-4040FR',
        workingPressure: '600(4.14)',
        operatingPressure: '225(1.55)',
        temperature: '45°C',
        activeArea: '85(7.9)',
        permeateFlux: '1900(7.2)',
        saltRejection: '99.5',
        recovery: '15'
      },
      {
        model: 'BW-8040FR',
        workingPressure: '600(4.14)',
        operatingPressure: '225(1.55)',
        temperature: '45°C',
        activeArea: '400(37)',
        permeateFlux: '10500(39.5)',
        saltRejection: '99.5',
        recovery: '15'
      }
    ],
    dimensions: [
      { model: 'BW-4021FR', length: '21"', diameter: '4.0"' },
      { model: 'BW-4040FR', length: '40"', diameter: '4.0"' },
      { model: 'BW-8040FR', length: '40"', diameter: '8.0"' }
    ]
  },
  'seawater-desalination-ro-membrane': {
    title: 'Sea Water Desalination (SW) RO Membrane Element Series',
    category: 'RO Membrane Series',
    description: 'Specialized reverse osmosis membrane elements designed for seawater desalination applications.',
    longDescription: 'SW Series RO membrane element is applicable to desalination of sea water. By optimizing the structure of membrane element, the SW series increases the permeate flow and requires fewer elements for same permeate flow. It is characterized by low operating pressure, low investment in equipment, excellent rejection rate and reliable performance, and its high salt rejection can ensure the production of the drinking water from sea water simply through one-pass RO design.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/4073b1acdfc641211dda123cf4d1dc29.png',
    features: [
      'Optimized structure for increased permeate flow',
      'Low operating pressure reduces equipment investment',
      'Excellent rejection rate for seawater',
      'One-pass drinking water production from seawater',
      'Reliable performance in harsh seawater conditions'
    ],
    specifications: {
      'Operating Pressure': '800 PSI (5.5 MPa)',
      'Max Feed Water Temperature': '45°C',
      'Active Area': '36-400 ft² (3.4-37 m²)',
      'Salt Rejection Rate': '99.6%',
      'Recovery Rate': '4-8%',
      'Max Feed Water Salinity': '40000 μg/cm',
      'Max Feed Water Hardness': '<60 ppm',
      'Max Feed Water COD': '<10 ppm',
      'Max Feed Water BOD': '<5 ppm',
      'Max Feed Water TOC': '<10 ppm',
      'Max Feed Water Free Chlorine': '<0.1 ppm',
      'Max Feed Water Turbidity NTU': '1.0',
      'Max Feed Water SDI 15': '<5',
      'Continuous Feed Water pH Range': '3-10',
      'Chemical Cleaning pH Range': '1-13'
    },
    testConditions: {
      'Temperature of Testing Solution': '25°C',
      'Concentration of Testing Solution (NaCl)': '32000ppm',
      'Operating Condition': '800psi (5.5MPa)',
      'pH Value of Testing Solution': '7.5-8',
      'Recovery Rate of Single Element': '8%',
      'Permeate Flow Variation': '±15%'
    },
    applications: [
      'Seawater desalination',
      'High concentration brackish water treatment',
      'High salt wastewater concentration and recycle treatment',
      'Boron removal for the focus on the desalination of sea water'
    ],
    models: [
      {
        model: 'SW-4021',
        workingPressure: '1200(8.27)',
        operatingPressure: '650(4.5)',
        temperature: '45°C',
        activeArea: '36(3.4)',
        permeateFlux: '750(2.8)',
        saltRejection: '99.6',
        recovery: '4'
      },
      {
        model: 'SW-4040',
        workingPressure: '1200(8.27)',
        operatingPressure: '650(4.5)',
        temperature: '45°C',
        activeArea: '106(9.9)',
        permeateFlux: '1600(6.1)',
        saltRejection: '99.6',
        recovery: '8'
      },
      {
        model: 'SW-8040',
        workingPressure: '1200(8.27)',
        operatingPressure: '650(4.5)',
        temperature: '45°C',
        activeArea: '400(37)',
        permeateFlux: '7500(28.4)',
        saltRejection: '99.6',
        recovery: '8'
      }
    ],
    dimensions: [
      { model: 'SW-4021', length: '21"', diameter: '4.0"' },
      { model: 'SW-4040', length: '40"', diameter: '4.0"' },
      { model: 'SW-8040', length: '40"', diameter: '8.0"' }
    ]
  }
};

export const roMembraneProductsList = [
  {
    id: 'residential-ro-membrane',
    name: 'Residential Series RO Membrane',
    category: 'RO Membrane Series',
    description: 'Compact membrane elements designed for home water treatment',
    features: ['Compact design', 'Various capacities', 'Easy installation'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/e61e11d0b3f7320d5e57a3d49e6eab82.png'
  },
  {
    id: 'ro-membrane-bw-series',
    name: 'RO Membrane BW-Series',
    category: 'RO Membrane Series',
    description: 'Brackish Water (BW) RO membrane elements with low-pressure operation and high permeate flow',
    features: ['Low-pressure operation', 'High permeate flow', 'Excellent desalination performance'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/4073b1acdfc641211dda123cf4d1dc29.png'
  },
  {
    id: 'ulp-ro-membrane',
    name: 'Ultra-Low Pressure (ULP) RO Membrane',
    category: 'RO Membrane Series',
    description: 'Energy-efficient membrane elements with ultra-low operating pressure',
    features: ['Low energy consumption', 'High salt rejection', 'Cost-effective operation'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/4073b1acdfc641211dda123cf4d1dc29.png'
  },
  {
    id: 'fouling-resistant-ro-membrane',
    name: 'Fouling Resistant (FR) RO Membrane',
    category: 'RO Membrane Series',
    description: 'Anti-fouling membrane elements for challenging water conditions',
    features: ['Excellent anti-fouling properties', 'Extended service life', 'High rejection rate'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/4073b1acdfc641211dda123cf4d1dc29.png'
  },
  {
    id: 'seawater-desalination-ro-membrane',
    name: 'Sea Water Desalination (SW) RO Membrane',
    category: 'RO Membrane Series',
    description: 'Specialized membranes for seawater desalination applications',
    features: ['Optimized for seawater', 'High rejection rate', 'Reliable performance'],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/4073b1acdfc641211dda123cf4d1dc29.png'
  }
];